import { render, staticRenderFns } from "./addScheme.vue?vue&type=template&id=5a05f10a&scoped=true&"
import script from "./addScheme.vue?vue&type=script&lang=js&"
export * from "./addScheme.vue?vue&type=script&lang=js&"
import style0 from "./addScheme.vue?vue&type=style&index=0&id=5a05f10a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a05f10a",
  null
  
)

export default component.exports